import axios from 'axios';

export const getPaymentStatus = async (sessionId) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/payment/statut/stripe`, {
      params: {
        sessionId: sessionId,
      },
    });
    return response;
  };